// Thank You / Conversion Success Page
// This page fires when customers complete actions

import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ConversionTracking from '../components/ConversionTracking';
import { trackFormSubmission } from '../utils/analytics';

const ThankYou = () => {
  const [searchParams] = useSearchParams();
  const source = searchParams.get('source') || 'website';
  const type = searchParams.get('type') || 'contact';

  useEffect(() => {
    // Track the successful conversion
    trackFormSubmission(type, source);

    // Fire Google Ads conversion tracking (exact snippet from Google Ads)
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'conversion', {'send_to': 'AW-17180193668/94BoCOChwNkaEITnk4BA'});
    }

    // Page title handled by static generation
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Thank you for contacting Colorado First Plumbing. We\'ll respond to your request within 2 hours during business hours.');
    }

    // Add noindex meta tag for crawl budget protection
    const existingNoIndex = document.querySelector('meta[name="robots"]');
    if (!existingNoIndex) {
      const noIndexMeta = document.createElement('meta');
      noIndexMeta.name = 'robots';
      noIndexMeta.content = 'noindex, nofollow';
      document.head.appendChild(noIndexMeta);
    }
  }, [source, type]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-trust-light to-neutral-light">
      <Header />
      
      {/* Fire conversion tracking */}
      <ConversionTracking 
        conversionType={type as any}
        source={source}
        value={type === 'emergency' ? 300 : type === 'booking' ? 200 : 150}
      />
      
      <main className="pt-32 pb-16">
        <div className="container-custom text-center">
          <div className="max-w-2xl mx-auto bg-white rounded-xl shadow-xl p-8 border border-success-primary/20">
            {/* Success Icon */}
            <div className="w-20 h-20 bg-success-primary rounded-full flex items-center justify-center mx-auto mb-6">
              <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            
            {/* Thank You Message */}
            <h1 className="text-3xl md:text-4xl font-bold text-authority-navy mb-4">
              Thank You!
            </h1>
            
            <p className="text-xl text-authority-dark mb-6">
              Your request has been received. We'll get back to you within <strong>2 hours</strong> during business hours.
            </p>
            
            {/* Contact Info */}
            <div className="bg-trust-light border border-trust-primary/20 rounded-lg p-6 mb-6">
              <h3 className="font-bold text-trust-deep mb-2">Need Immediate Help?</h3>
              <div className="space-y-2">
                <p className="text-authority-dark">
                  <strong>Emergency Service:</strong> Available 24/7
                </p>
                
              </div>
            </div>
            
            {/* What's Next */}
            <div className="text-left bg-neutral-light rounded-lg p-6 mb-6">
              <h3 className="font-bold text-authority-navy mb-3">What Happens Next:</h3>
              <ol className="space-y-2 text-authority-dark">
                <li className="flex items-start">
                  <span className="w-6 h-6 bg-success-primary text-white rounded-full flex items-center justify-center text-sm font-bold mr-3 mt-0.5">1</span>
                  We'll review your request and service needs
                </li>
                <li className="flex items-start">
                  <span className="w-6 h-6 bg-success-primary text-white rounded-full flex items-center justify-center text-sm font-bold mr-3 mt-0.5">2</span>
                  A licensed plumber will contact you directly
                </li>
                <li className="flex items-start">
                  <span className="w-6 h-6 bg-success-primary text-white rounded-full flex items-center justify-center text-sm font-bold mr-3 mt-0.5">3</span>
                  We'll schedule your service at your convenience
                </li>
              </ol>
            </div>
            
            {/* Call to Action */}
            <div className="space-y-4">
              <a 
                href="/pricing" 
                className="inline-block bg-gradient-to-r from-trust-primary to-trust-deep text-white px-6 py-3 rounded-lg font-semibold hover:shadow-lg transition-all duration-300"
              >
                View Our Transparent Pricing
              </a>
              <br />
              <a 
                href="/" 
                className="text-authority-dark hover:text-trust-primary transition-colors"
              >
                ← Return to Homepage
              </a>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default ThankYou;